<template>
  <div class="wscn-http404-container">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" src="@/assets/image/404/404.png" alt="404">
        <img class="pic-404__child left" src="@/assets/image/404/404_cloud.png" alt="404">
        <img class="pic-404__child mid" src="@/assets/image/404/404_cloud.png" alt="404">
        <img class="pic-404__child right" src="@/assets/image/404/404_cloud.png" alt="404">
      </div>
      <div class="bullshit">
        <div class="bullshit__status">404</div>
        <div class="bullshit__oops">页面走丢了</div>
        <div class="bullshit__info">保留所有权利。
          <router-link class="bullshit__link" :to="{name:'Home'}" target="_blank">返回主页</router-link>
        </div>
        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">请检查您输入的网址是否正确，或单击下面的按钮返回主页。</div>
        <router-link :to="{name:'Home'}"  class="bullshit__return-home">回到首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  computed: {
    message() {
      return '站长说你进不去这个页面...'
    },
  }
}
</script>

<style lang="less" scoped>
.wscn-http404-container {
  width: 100%;
  min-width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  background: var(--bg-page, #F7F5F2);
}
.wscn-http404 {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 64px;
  position: relative;
  width: 100%;
  max-width: 1200px;
  padding: 0 64px 0 0;
  overflow: visible;
  transform: translateY(-32px);
  .pic-404 {
    position: relative;
    flex: 0 1 700px;
    width: 100%;
    max-width: 700px;
    min-height: 320px;
    aspect-ratio: 3 / 2;
    overflow: hidden;
    transform: translateY(18px);
    &__parent {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    &__child {
      position: absolute;
      &.left {
        width: 80px;
        top: 17px;
        left: 220px;
        opacity: 0;
        animation-name: cloudLeft;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }
      &.mid {
        width: 46px;
        top: 10px;
        left: 420px;
        opacity: 0;
        animation-name: cloudMid;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1.2s;
      }
      &.right {
        width: 62px;
        top: 100px;
        left: 500px;
        opacity: 0;
        animation-name: cloudRight;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }
      @keyframes cloudLeft {
        0% {
          top: 17px;
          left: 220px;
          opacity: 0;
        }
        20% {
          top: 33px;
          left: 188px;
          opacity: 1;
        }
        80% {
          top: 81px;
          left: 92px;
          opacity: 1;
        }
        100% {
          top: 97px;
          left: 60px;
          opacity: 0;
        }
      }
      @keyframes cloudMid {
        0% {
          top: 10px;
          left: 420px;
          opacity: 0;
        }
        20% {
          top: 40px;
          left: 360px;
          opacity: 1;
        }
        70% {
          top: 130px;
          left: 180px;
          opacity: 1;
        }
        100% {
          top: 160px;
          left: 120px;
          opacity: 0;
        }
      }
      @keyframes cloudRight {
        0% {
          top: 100px;
          left: 500px;
          opacity: 0;
        }
        20% {
          top: 120px;
          left: 460px;
          opacity: 1;
        }
        80% {
          top: 180px;
          left: 340px;
          opacity: 1;
        }
        100% {
          top: 200px;
          left: 300px;
          opacity: 0;
        }
      }
    }
  }
  .bullshit {
    position: relative;
    flex: 0 0 340px;
    width: 340px;
    box-sizing: border-box;
    padding: 0;
    overflow: hidden;
    &__status {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      height: 32px;
      padding: 0 14px;
      margin-bottom: 18px;
      border-radius: 4px;
      background: rgba(26, 29, 36, 0.12);
      border: 1px solid rgba(26, 29, 36, 0.18);
      color: var(--text-main, #1A1D24);
      font-size: 14px;
      font-weight: 600;
      line-height: 32px;
      opacity: 0;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    &__oops {
      font-size: 34px;
      font-weight: 700;
      line-height: 42px;
      color: var(--text-main, #111827);
      opacity: 0;
      margin-bottom: 14px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.06s;
      animation-fill-mode: forwards;
    }
    &__headline {
      font-size: 18px;
      line-height: 28px;
      color: var(--text-main, #111827);
      font-weight: 600;
      opacity: 0;
      margin-bottom: 12px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.12s;
      animation-fill-mode: forwards;
    }
    &__info {
      font-size: 14px;
      line-height: 24px;
      color: var(--text-secondary, #5A5F6B);
      opacity: 0;
      margin-bottom: 22px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.18s;
      animation-fill-mode: forwards;
    }
    &__link {
      color: var(--primary, #FF5A1F);
      font-weight: 500;
    }
    &__return-home {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 128px;
      height: 42px;
      padding: 0 22px;
      box-sizing: border-box;
      background: var(--bg-dark, #1A1D24);
      border-radius: 4px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 14px;
      line-height: 36px;
      cursor: pointer;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.24s;
      animation-fill-mode: forwards;
      box-shadow: 0 10px 20px rgba(26, 29, 36, 0.18);
      transition: transform 0.2s ease, box-shadow 0.2s ease;
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 14px 26px rgba(26, 29, 36, 0.22);
      }
    }
    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}

@media (max-width: 900px) {
  .wscn-http404-container {
    padding: 40px 16px;
  }
  .wscn-http404 {
    flex-direction: column;
    gap: 28px;
    padding: 0;
    transform: translateY(-12px);
    .pic-404 {
      flex-basis: auto;
      max-width: 520px;
      min-height: 240px;
    }
    .bullshit {
      flex: none;
      width: 100%;
      max-width: 520px;
      padding: 0;
      text-align: center;
      &__return-home {
        margin: 0 auto;
      }
    }
  }
}

@media (max-width: 480px) {
  .wscn-http404-container {
    padding: 24px 12px;
  }
  .wscn-http404 {
    .pic-404 {
      min-height: 190px;
    }
    .bullshit {
      &__oops {
        font-size: 28px;
        line-height: 36px;
      }
      &__headline {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
</style>
